import {withStyles} from 'material-ui/styles';
import {builderStyles} from '../../style/builder';
import {pageSectionDropTarget} from '../../dsdt/section_drop_target';
import {pageSectionDragSource} from '../../dsdt/section_drag_source';
import BaseSection from './section_base';

const card = withStyles(builderStyles)(BaseSection);

const pageSection = pageSectionDropTarget(
    pageSectionDragSource(card)
);

export default pageSection;



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_group_trips_banner.js